import { render, staticRenderFns } from "./CreateTagView.vue?vue&type=template&id=1e3ede71"
import script from "./CreateTagView.vue?vue&type=script&lang=js"
export * from "./CreateTagView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports